import { classesBuilder } from '@common/helpers';

import type { IBaseButtonProps } from './types';

import style from './styles.module.scss';

const BaseButton = ({ children, className, ...props }: IBaseButtonProps) => {
  return (
    <button
      className={classesBuilder(style.button, className)}
      {...props}
    >
      {children}
    </button>
  );
};

export default BaseButton;
